import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import Route from 'cio/routes/base';

export default class LayoutRoute extends Route {
  @service store;

  crumb() {
    let model = this.modelFor(this.routeName);

    return {
      name: readOnly('model.name'),
      path: 'layout.index',
      model,
    };
  }

  model(params) {
    return this.store.findRecord('layout', params.layout_id);
  }
}
